import React from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setSection } from "../actions";
import "../assets/styles/components/Header.scss";
import Logo from "../assets/static/images/logo.png";

const Header = () => {
  const sectionActive = useSelector((state) => state.sectionActive);
  const dispatch = useDispatch();

  const handleSetSection = (section) => {
    dispatch(setSection(section));
  };
  return (
    <header className="header">
      <figure className="header-logo">
        <img className="header-logo-img" src={Logo} alt="Netflix" />
      </figure>
      <nav className="header-nav">
        <ul className="header-nav-options">
          <li
            onClick={() => handleSetSection("Movies")}
            className={`header-nav-options-item ${
              sectionActive === "Movies" ? "active" : ""
            }`}
          >
            <Link to="/">Movies</Link>
          </li>
          <li
            onClick={() => handleSetSection("Series")}
            className={`header-nav-options-item ${
              sectionActive === "Series" ? "active" : ""
            }`}
          >
            <Link to="/series">Series</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
